import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import IconWrapper from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";

export const FilterToggle = styled.span`
    display: flex;
    position: relative;
    align-items: center;
    gap: ${theme.space[1]}px;
    padding: 12px 0 17px;
    cursor: pointer;
    user-select: none;

    svg {
        margin-right: ${theme.space[1]}px;
        transition: color 0.3s;
    }

    html[dir="rtl"] & {
        svg {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;

export const FilterBadge = styled.span<{ selected: boolean }>`
    display: flex;
    position: absolute;
    top: 6px;
    left: 12px;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    font-size: 0.8rem;
    line-height: 1;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.6);
    ${({ selected }) => css`
        font-family: ${theme.fonts.semiBold};
        color: ${theme.colors.primaryRed};
        background: ${theme.colors.primaryWhite};
        border: 2px solid ${theme.colors.primaryRed};
        ${selected &&
        css`
            color: ${theme.colors.primaryBlack};
            border: 2px solid ${theme.colors.primaryBlack};
        `};
    `};

    html[dir="rtl"] & {
        left: auto;
        right: 12px;
    }
`;

export const FilterPopover = styled.div`
    position: absolute;
    top: 42px;
    left: 0;
    right: 0;
    min-width: 335px;
    padding: ${theme.space[2]}px ${theme.space[3]}px;
    background-color: ${theme.colors.primaryWhite};
    border-radius: 4px;
    box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.25);
    z-index: 2055;
    /* className="or-extras-filter-overlay or-popover or-popover-without-point" */
`;

export const FilterPopoverLine = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid ${theme.colors.grey2};
    cursor: pointer;
    user-select: none;
    span {
        svg,
        i {
            margin-right: ${theme.space[3]}px;
        }
    }
    svg {
        position: relative;
        top: 2px;
        color: ${theme.colors.primaryBlack};
        transition: color 0.3s;
    }
    &:hover svg {
        color: ${theme.colors.primaryRed};
    }

    html[dir="rtl"] & {
        span {
            svg,
            i {
                margin-left: ${theme.space[3]}px;
                margin-right: 0;
            }
        }
    }
`;

export const FilterPopoverTitle = styled.div<SpaceProps>`
    margin-bottom: ${theme.space[3]}px;
    ${space};
`;

export const DropdownLine = styled.div``;

export const ResetButton = styled.button`
    display: flex;
    position: absolute;
    top: 50%;
    right: 0;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 0;
    transform: translateY(-50%);

    ${Icon} {
        &::before {
            font-size: 1.6rem;
        }
    }

    html[dir="rtl"] & {
        left: 0;
        right: auto;
    }
`;

export const InputGroup = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-width: 300px;
    border-radius: 4px;

    ${IconWrapper} {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }

    &:focus-within {
        ${IconWrapper} {
            left: ${theme.space[1]}px;
        }
        ${ResetButton} {
            right: ${theme.space[1]}px;
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        width: auto;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            left: auto;
            right: 0;
        }
        &:focus-within {
            ${IconWrapper} {
                left: auto;
                right: ${theme.space[1]}px;
            }
            ${ResetButton} {
                left: ${theme.space[1]}px;
                right: auto;
            }
        }
    }
`;

export const InputGroupPrepend = styled.input`
    width: 100%;
    padding: ${theme.space[1]}px ${theme.space[3]}px;
    padding-left: ${theme.space[4]}px;
    font-size: 1.5rem;
    color: ${theme.colors.grey4};
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid ${theme.colors.grey7};
    border-radius: 0;

    &:focus {
        background-color: ${theme.colors.primaryWhite};
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: ${theme.space[4]}px;
    }
`;
